import { Reveal, Stagger, StaggerItem } from "../components/motion";
import { SectionLabel, PillButton, PageHero } from "../components/ui-kit";
import { Target, Eye, ArrowRight } from "lucide-react";

const FOUNDER_IMG = "https://customer-assets-lqy194kg.emergentagent.net/job_strength-authority/artifacts/znd6icox_1786026011187682.jpeg";
const gallery = [
  "https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHero label="About" title={<>The coach behind <span className="text-accent">the results.</span></>}
        subtitle="Manav Shah — turning busy professionals into their strongest, leanest selves through science, structure and accountability." />

      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-5">
            <Reveal>
              <div className="rounded-3xl overflow-hidden hover-lift">
                <img src={FOUNDER_IMG} alt="Manav Shah" className="w-full h-[600px] object-cover object-top" />
              </div>
            </Reveal>
          </div>
          <div className="md:col-span-7">
            <Reveal>
              <SectionLabel index="01">My Story</SectionLabel>
              <p className="text-lg text-muted-foreground leading-relaxed mb-5">
                I started my journey like most people — confused, inconsistent, and overwhelmed by conflicting advice online. After years of trial, error and studying the science of training and nutrition, I transformed my own body and lifestyle.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-5">
                Since then I've dedicated my career to helping busy professionals do the same — without extreme diets, endless cardio, or giving up the life they love. Over 500 clients later, my approach remains simple: evidence-based coaching, tailored to your reality, delivered with genuine care.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                I believe fitness should make your life bigger, not smaller. That's the standard I hold for every single client.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="py-20 border-t border-border">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-6">
          {[{ icon: Target, t: "Mission", d: "To help 10,000 busy professionals build strong, healthy bodies and unshakeable consistency — through honest, science-backed coaching." },
            { icon: Eye, t: "Vision", d: "A world where fitness is simple, sustainable and empowering — free from gimmicks, fear and misinformation." }].map((c) => (
            <Reveal key={c.t}>
              <div className="glass rounded-2xl p-10 h-full hover-lift">
                <span className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center mb-5"><c.icon className="w-6 h-6 text-accent" /></span>
                <h3 className="font-heading font-black text-2xl mb-3">{c.t}</h3>
                <p className="text-muted-foreground leading-relaxed">{c.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-20 border-t border-border">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <SectionLabel index="02">Gallery</SectionLabel>
          <h2 className="text-3xl md:text-5xl font-black tracking-tight mb-12">In the trenches.</h2>
          <Stagger className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {gallery.map((g, i) => (
              <StaggerItem key={i}>
                <div className="rounded-2xl overflow-hidden aspect-[3/4] group">
                  <img src={g} alt="" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="py-20 border-t border-border text-center">
        <div className="max-w-3xl mx-auto px-6">
          <Reveal>
            <h2 className="text-3xl md:text-5xl font-black tracking-tight mb-8">Let's build your best chapter yet.</h2>
            <PillButton to="/coaching" testid="about-cta">Apply For Coaching <ArrowRight className="w-4 h-4 ml-2" /></PillButton>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
